import clsx from "clsx";
import { useLocation } from "wouter";

import OwnershipLeaderboardPage from "./OwnershipLeaderboardPage";
import WageringLeaderboardPage from "./WageringLeaderboardPage";

type LeaderboardView = "ownership" | "wagering";

export default function LeaderboardPage() {
  const [location, navigate] = useLocation();
  const view: LeaderboardView = location.endsWith("/wagering")
    ? "wagering"
    : "ownership";

  const selectView = (nextView: LeaderboardView) => {
    navigate(`/app/leaderboards/${nextView}`);
  };

  return (
    <div className="page page--leaderboard">
      <div
        aria-label="Leaderboard categories"
        className="leaderboard-tabs leaderboard-view-tabs"
        role="tablist"
      >
        <button
          aria-controls="ownership-leaderboard-panel"
          aria-selected={view === "ownership"}
          className={clsx(view === "ownership" && "is-active")}
          id="ownership-leaderboard-tab"
          onClick={() => selectView("ownership")}
          role="tab"
          type="button"
        >
          Ownership
        </button>
        <button
          aria-controls="wagering-leaderboard-panel"
          aria-selected={view === "wagering"}
          className={clsx(view === "wagering" && "is-active")}
          id="wagering-leaderboard-tab"
          onClick={() => selectView("wagering")}
          role="tab"
          type="button"
        >
          Wagering
        </button>
      </div>

      <section
        aria-labelledby={`${view}-leaderboard-tab`}
        id={`${view}-leaderboard-panel`}
        role="tabpanel"
      >
        {view === "ownership" ? (
          <OwnershipLeaderboardPage />
        ) : (
          <WageringLeaderboardPage />
        )}
      </section>
    </div>
  );
}
